import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  QueryList,
  OnChanges,
  ViewChildren,
} from '@angular/core';
import { FacetChipViewModel } from '@app/new-search/models/facet-filter.model';
import {
  FacetViewEvent,
  FacetViewOperation,
  ListFacetSharedObject,
  ListFacetValue,
  ToggleFacetEvent,
} from '@app/new-search/models/new-search-facets.model';
import {
  GeneratedFacetControllers,
  RegularFacet,
  CategoryFacet,
} from '@coveo/headless/commerce';
import {
  IonAccordion,
  IonAccordionGroup,
  IonContent,
  IonMenu,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformEnum } from '@panamax/app-state';
import { ChipTypeEnum } from '@app/shared-product/components/usf-chip/models/chip-type.enum';

@Component({
  selector: 'app-facet-flyout-container',
  templateUrl: './facet-flyout-container.component.html',
  styleUrls: ['./facet-flyout-container.component.scss'],
})
export class FacetFlyoutContainerComponent implements OnChanges {
  @Input() facetFlyoutTitle: string;
  @Input() platformType: PlatformEnum;
  readonly platformEnum = PlatformEnum;
  readonly chipTypeEnum = ChipTypeEnum;
  readonly facetViewEnum = FacetViewOperation;
  @Input() facets: GeneratedFacetControllers = [];
  @Input() facetChipViewModels: FacetChipViewModel[] = [];
  @Input() isLoading = false;
  @Input() listFacet: ListFacetSharedObject;
  currentFacetId: string;
  isLoadingFacetValues = false;
  @ViewChild(IonMenu) ionMenu: IonMenu;
  @ViewChild(IonAccordionGroup) ionAccordionGroup: IonAccordionGroup;
  @Output() facetsSelected = new EventEmitter<ToggleFacetEvent>();
  @Output() clearAll = new EventEmitter<any>();
  @Output() facetLoadValues = new EventEmitter<FacetViewEvent>();
  @Output() facetListSelected = new EventEmitter<void>();
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChildren(IonAccordion) accordionItems: QueryList<IonAccordion>;

  constructor(private translateService: TranslateService) {}

  ngOnChanges(): void {
    this.scrollToCurrentFacet();
  }

  scrollToCurrentFacet() {
    setTimeout(() => {
      if (this.accordionItems && !this.isLoadingFacetValues) {
        const targetAccordion = this.accordionItems
          .toArray()
          .find(({ value }) => value === this.currentFacetId);
        if (targetAccordion) {
          targetAccordion['el'].scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }
      this.isLoadingFacetValues = false;
    }, 500);
  }

  openFlyout(openWithFacet?: string) {
    this.ionMenu.open();
    const nativeEl = this.ionAccordionGroup;
    nativeEl.value = openWithFacet ?? undefined;
  }

  closeFlyout() {
    this.content.scrollToPoint(0, 0, 0);
    this.resetExpandedFacets();
    this.ionMenu.close();
  }

  closeAndClearAll() {
    this.resetExpandedFacets();
    this.clearAll.emit();
    this.clearAllListFacet();
    this.ionMenu.close();
  }

  handleCheckboxSelection(event: ToggleFacetEvent) {
    this.currentFacetId = event?.facet.state.facetId;
    this.facetsSelected.emit({ facet: event?.facet, value: event?.value });
  }

  onUnselectFacet(facet, value) {
    this.currentFacetId = facet.state.facetId;
    this.facetsSelected.emit({ facet: facet, value: value });
  }

  viewMoreOrLessFacetValues(event: FacetViewEvent) {
    this.isLoadingFacetValues = true;
    this.facetLoadValues.emit({
      facet: event?.facet,
      operation: event?.operation,
    });
  }

  showLessFacetValues(facet: RegularFacet | CategoryFacet) {
    this.facetLoadValues.emit({
      facet,
      operation: this.facetViewEnum.viewLess,
    });
    this.currentFacetId = facet.state.facetId;
    this.scrollToCurrentFacet();
  }

  trackFacetId(index: number, facet: any) {
    return facet.state.facetId;
  }

  trackFacetValueId(index: number, facetValue: any) {
    return facetValue.value;
  }

  resetExpandedFacets() {
    this.facets.forEach(facet => {
      if (facet.type === 'regular' && facet.state.canShowLessValues) {
        this.facetLoadValues.emit({
          facet,
          operation: this.facetViewEnum.viewLess,
        });
      }
    });
  }

  handleListFacetCheckboxSelection(listFacetValue: ListFacetValue) {
    this.currentFacetId = this.listFacet?.displayName;
    this.listFacet.values.get(listFacetValue.id).isSelected =
      !listFacetValue.isSelected;
    this.listFacet.isValuesSelected = this.checkIsListFaceSelected();
    this.facetListSelected.emit();
  }

  clearListFacet(listFacetValue: ListFacetValue) {
    this.currentFacetId = '';
    this.listFacet.values.get(listFacetValue.id).isSelected = false;
    this.listFacet.isValuesSelected = this.checkIsListFaceSelected();
    this.facetListSelected.emit();
  }

  clearAllListFacet() {
    this.listFacet.values.forEach((value, key) => {
      value.isSelected = false;
    });
    this.listFacet.isValuesSelected = false;
    this.facetListSelected.emit();
  }

  checkIsListFaceSelected(): boolean {
    let val = false;
    this.listFacet.values.forEach((value, key) => {
      if (value.isSelected) {
        val = true;
      }
    });
    return val;
  }

  setCurrentFacetId(facetId) {
    this.currentFacetId = facetId;
  }
}
